// src/com/file_of_report/TsrResultReportGql.js
import { gql } from "@apollo/client";

/*

extend type Mutation {
    tsrResultReportAdd(tsrResultReport: InputTsrResultReportAdd!): ResponseWithFileCreateHisItem!
}

# 출고실적 레포트 조회용 입력. 운송사 여부에 따라 서비스 내에서 분기.
input InputTsrResultReportAdd {
    dateFrom: String!
    dateTill: String!
}

*/

export const CREATE_TSR_RESULT_REPORT = gql`
mutation CreateTsrResultReport($tsrResultReport:InputTsrResultReportAdd!) {
    tsrResultReportAdd(tsrResultReport: $tsrResultReport) {
        ok
        message
        item {
            fileCreateHisSeq
        }
    }
}
`;
